import React, { useState } from 'react';
import { rewardService } from '../api/services';
import AdminModal from './AdminModal';

// 兌換 pop up：選擇數量、填備註，顯示總點數，送出兌換申請（PENDING，待審核者同意才扣點）。
const RewardRedeemModal = ({ item, remaining, onClose, onSubmitted }) => {
  const [quantity, setQuantity] = useState(1);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const qty = Math.max(1, Number(quantity) || 1);
  const total = item.points_cost * qty;
  const stockLimited = item.stock !== null && item.stock !== undefined;
  const overStock = stockLimited && qty > item.stock;
  const overPoints = total > remaining;

  const handleSubmit = async () => {
    if (overStock) { setError('超過庫存數量'); return; }
    if (overPoints) { setError('剩餘點數不足'); return; }
    setBusy(true);
    setError('');
    try {
      await rewardService.redeem(item.id, { quantity: qty });
      onSubmitted?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
      setBusy(false);
    }
  };

  return (
    <AdminModal title={`兌換：${item.name}`} onClose={onClose}>
      {error && <div className="alert alert-danger">{error}</div>}
      {item.image_url && <img src={item.image_url} alt={item.name} style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 10, marginBottom: 12 }} />}
      <div className="reward-redeem-summary">
        <div>單件所需點數：<strong>{item.points_cost}</strong></div>
        <div>目前剩餘點數：<strong>{remaining}</strong></div>
        {stockLimited && <div>商品庫存：<strong>{item.stock}</strong></div>}
      </div>
      <label>兌換數量</label>
      <input
        className="form-control form-control-sm"
        type="number"
        min="1"
        max={stockLimited ? item.stock : undefined}
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
      />
      <div className="reward-redeem-total" style={{ marginTop: 12 }}>
        共需點數：<strong>{total}</strong>
      </div>
      {overPoints && <div className="alert alert-danger" style={{ marginTop: 8 }}>剩餘點數不足，無法兌換</div>}
      {overStock && <div className="alert alert-danger" style={{ marginTop: 8 }}>超過商品庫存</div>}
      <div className="btn-group" style={{ justifyContent: 'flex-end', marginTop: 16 }}>
        <button className="btn btn-sm btn-primary" disabled={busy || overPoints || overStock} onClick={handleSubmit}>{busy ? '送出中...' : '提出兌換'}</button>
        <button className="btn btn-sm btn-secondary" disabled={busy} onClick={onClose}>取消</button>
      </div>
    </AdminModal>
  );
};

export default RewardRedeemModal;
